import { HttpInterceptorFn } from '@angular/common/http';
import { localStorageKeys, SCOPED_AUTH_SENTINEL_HEADER } from '../constants/common.const';

export const ownerAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const raw = localStorage.getItem(localStorageKeys.ownerTokenData);
  if (!raw) return next(req);
  const ownerToken = (JSON.parse(raw) as { token?: string })?.token;
  if (!ownerToken) return next(req);
  // Only attach the owner token when the user is actively on the /owner route.
  // Without this guard a cabinet ORGANIZATOR/ADMIN session navigating to
  // /statistic/reports would get the owner token injected on excel-report-builder
  // calls, replacing the cabinet Bearer and bypassing role checks.
  const isOwnerPath =
    typeof window !== 'undefined' && window.location.pathname.startsWith('/owner');
  if (!isOwnerPath) return next(req);

  const isOwnerUrl =
    req.url.includes('/event-owner-management/') ||
    req.url.includes('/excel-report-builder/') ||
    req.url.includes('/generative/report-filter-name');
  if (!isOwnerUrl) return next(req);
  // Clone with owner Bearer + sentinel header; authInterceptor will strip sentinel and skip
  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${ownerToken}`,
        [SCOPED_AUTH_SENTINEL_HEADER]: '1',
      },
    }),
  );
};
